'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

exports.default = client;

require('babel-polyfill');

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactDom = require('react-dom');

var _reactDom2 = _interopRequireDefault(_reactDom);

var _redux = require('redux');

var _reactRedux = require('react-redux');

var _reduxConnect = require('redux-connect');

var _reactRouter = require('react-router');

var _useStandardScroll = require('scroll-behavior/lib/useStandardScroll');

var _useStandardScroll2 = _interopRequireDefault(_useStandardScroll);

var _reactRouterRedux = require('react-router-redux');

var _routes = require('./routes');

var _routes2 = _interopRequireDefault(_routes);

var _trvFedMockedFetch = require('./trv-fed-mocked-fetch');

var _trvFedMockedFetch2 = _interopRequireDefault(_trvFedMockedFetch);

var _logger = require('./modules/logger');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var defaults = {
  reducer: undefined // require('./modules/reducer')
};

function render(_ref) {
  var store = _ref.store,
      history = _ref.history,
      dest = _ref.dest;

  _reactDom2.default.render(_react2.default.createElement(
    _reactRedux.Provider,
    { store: store, key: 'provider' },
    _react2.default.createElement(_reactRouter.Router, {
      render: function render(props) {
        return _react2.default.createElement(_reduxConnect.ReduxAsyncConnect, (0, _extends3.default)({}, props, { filter: function filter(item) {
            return !item.deferred;
          } }));
      },
      history: history,
      routes: (0, _routes2.default)(store)
    })
  ), dest);
}

function client() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : defaults;

  if (options.mockedResources) {
    // Mock global fetch with mocks/resources.json
    (0, _trvFedMockedFetch2.default)(options.mockedResources);
  }

  var dest = document.getElementById('react-container');
  var store = (0, _redux.createStore)(options.reducer, window.__data, (0, _redux.applyMiddleware)((0, _reactRouterRedux.routerMiddleware)(_reactRouter.browserHistory)));
  var pathname = location.pathname;
  var scrollHistory = (0, _useStandardScroll2.default)(function () {
    return _reactRouter.browserHistory;
  })({
    shouldUpdateScroll: function shouldUpdateScroll(oldLocation, newLocation) {
      // Don't scroll if the pathname is the same
      if (oldLocation) {
        return newLocation.pathname !== oldLocation.pathname;
      }
      // XXX: This is a workarround. First time to get the page, oldLocation is undefined.
      //      So, it use cached pathname which has stored when page loaded.
      return newLocation.pathname !== pathname;
    }
  });
  var history = (0, _reactRouterRedux.syncHistoryWithStore)(scrollHistory, store);

  if (options.logging) {
    store.dispatch((0, _logger.enable)());
  }

  if (!window.Intl) {
    // XXX: A workaround for browsers (mainly iOS Safari) without the Intl Web API
    require.ensure(['intl', 'intl/locale-data/jsonp/en-US', 'intl/locale-data/jsonp/en-MY', 'intl/locale-data/jsonp/en-SG', 'intl/locale-data/jsonp/fr-FR', 'intl/locale-data/jsonp/id-ID', 'intl/locale-data/jsonp/ko-KR', 'intl/locale-data/jsonp/th-TH', 'intl/locale-data/jsonp/zh'], function (require) {
      require('intl');
      require('intl/locale-data/jsonp/en-US');
      require('intl/locale-data/jsonp/en-MY');
      require('intl/locale-data/jsonp/en-SG');
      require('intl/locale-data/jsonp/fr-FR');
      require('intl/locale-data/jsonp/id-ID');
      require('intl/locale-data/jsonp/ko-KR');
      require('intl/locale-data/jsonp/th-TH');
      require('intl/locale-data/jsonp/zh');

      render({ store: store, history: history, dest: dest });
    });
  } else {
    render({ store: store, history: history, dest: dest });
  }

  if (process.env.NODE_ENV !== 'production') {
    window.React = _react2.default; // enable debugger

    if (!dest || !dest.firstChild || !dest.firstChild.attributes || !dest.firstChild.attributes['data-react-checksum']) {
      console.error('Server-side React render was discarded. Make sure that your initial render does not contain any client-side code.');
    }
  }
}
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/trv-fed-client.js
// module id = 1250
// module chunks = 0